import * as React from 'react'

import { getFio } from 'helpers/formatText'
import { usePagination } from 'hooks/usePagination'
import { useGetRegionsQuery } from 'redux/services/common'
import {
  SupervisorsApi,
  SupervisorsParams,
  SwapSupervisorsDTO,
} from 'services/api/SupervisorsApi'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { ISupervisor } from 'models/supervisor'

import { SupervisorDetails } from './components/SupervisorDetails'
import { SupervisorDetailsEmpty } from './components/SupervisorDetailsEmpty'
import { SupervisorsDetailsHeader } from './components/SupervisorsDetailsHeader'

export const SupervisorsPage: React.FC = () => {
  const { data: regions = [], isSuccess } = useGetRegionsQuery()

  const [disabled, setDisabled] = React.useState(false)
  const [details, setDetails] = React.useState<ISupervisor | null>(null)

  const { page, list, count, getList, setParams } = usePagination(
    SupervisorsApi.getSupervisors,
  )

  const applyFilters = (filters: SupervisorsParams) => {
    setParams(filters)
    getList(1, filters)
    closeDetails()
  }

  const openDetails = async (application: ISupervisor) => {
    try {
      if (application.id === details?.id) {
        return
      }
      closeDetails()
      setDetails(application)
    } catch (error) {}
  }

  const onSwap = async (body: SwapSupervisorsDTO) => {
    try {
      setDisabled(true)
      await SupervisorsApi.swapSupervisors(body)

      getList()
      closeDetails()
    } catch (error) {}
  }

  const closeDetails = () => {
    setDetails(null)
  }

  if (!isSuccess) {
    return null
  }

  return (
    <>
      <AppLayoutTable
        header={
          <SupervisorsDetailsHeader onSubmit={applyFilters} regions={regions} />
        }
        sidebarOpened={Boolean(details)}
        sidebar={
          details === null ? (
            <SupervisorDetailsEmpty />
          ) : (
            <SupervisorDetails
              disabled={disabled}
              supervisors={list.filter(
                supervisor => supervisor.id !== details.id,
              )}
              onClose={closeDetails}
              supervisor={details}
              onSwap={onSwap}
            />
          )
        }
        title="Супервайзеры"
      >
        <AppTable
          selected={{
            value: details?.id,
            key: 'id',
          }}
          onClickRow={openDetails}
          headers={[
            {
              data: 'ID',
              key: 'id',
              width: 10,
            },
            {
              data: 'Ф.И.О',
              key: 'first_name',
              render: (_, data) => {
                return getFio(data)
              },
            },
            {
              data: 'Номер',
              key: 'phone',
              render: (_, data) => data.phone,
            },
            {
              data: 'Регион',
              key: 'region',
              render: (_, data) => {
                return data.region_name
              },
            },
          ]}
          dataSource={list}
        />
      </AppLayoutTable>
      {count > 0 ? (
        <AppPagination
          forcePage={page - 1}
          onPageChange={getList}
          count={count}
        />
      ) : null}
    </>
  )
}
